import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../Redux/authSlice';
import loaderReducer from '../Redux/loaderSlice';
import thunk from 'redux-thunk';
export const store = configureStore({
  reducer: {
    authReducer: authReducer,
    loaderReducer: loaderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk), // Integrate redux-thunk
});
